<template>
  <ItemPage
    title="Novo Material"
    size="sm"
    :actions="actions"
  >
    <div
      v-if="subjectTextBooksCreate"
      class="white"
    >
      <v-row
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="6"
        >
          <div class="font-weight-bold">
            Capa do material
          </div>
        </v-col>
        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            v-if="displayCoverButton"
            color="primary"
            text
            :disabled="loadingCover"
            @click="openUploadCoverDialog"
          >
            <v-icon left>
              mdi-cloud-upload
            </v-icon> {{ loadingCover? 'Enviando...' : 'Enviar capa' }}
          </v-btn>
          <template v-else>
            <v-icon
              left
              color="green darken-2"
            >
              mdi-cloud-check
            </v-icon> Capa enviada
          </template>
        </v-col>
      </v-row>
      <v-row
        class="mt-10 mb-10"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="6"
        >
          <div class="font-weight-bold">
            Material
          </div>
          <div class="text-body-2 text--secondary mt-1">
            Envie o material no formato (*.zip) e aguarde sua publicação.
          </div>
        </v-col>
        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            v-if="displayMaterialButton"
            color="primary"
            text
            :disabled="loadingMaterial"
            @click="openUploadMaterialDialog"
          >
            <v-icon left>
              mdi-cloud-upload
            </v-icon> {{ loadingMaterial? 'Enviando...' : 'Enviar arquivo' }}
          </v-btn>

          <template v-else>
            <v-icon
              left
              color="green darken-2"
            >
              mdi-cloud-check
            </v-icon> Arquivo enviado
          </template>
        </v-col>
      </v-row>

      <v-form
        ref="form"
        :disabled="formDisabled"
      >
        <v-row>
          <v-col
            cols="4"
            class="mr-auto"
          >
            <v-select
              v-model="type"
              :error-messages="formErrors.type"
              :items="types"
              item-text="name"
              item-value="id"
              label="Tipo"
              outlined
              @change="formErrors.type = null"
            />
          </v-col>
          <v-col
            cols="4"
            class="mr-auto"
          >
            <v-select
              v-model="teaching_system_id"
              :error-messages="formErrors.teaching_system_id"
              :items="systems"
              item-text="name"
              item-value="id"
              :readonly="type ? false : true"
              label="Sistemas de ensino"
              placeholder="Escolha o sistema de ensino"
              hide-details="auto"
              outlined
              @change="formErrors.teaching_system_id = null"
            />
          </v-col>
          <v-col
            cols="4"
            class="mr-auto"
          >
            <v-select
              v-model="publishing_year"
              :error-messages="formErrors.publishing_year"
              :items="years"
              label="Ano de publicação"
              :readonly="teaching_system_id ? false : true"
              placeholder="Escolha o ano de publicação"
              hide-details="auto"
              outlined
              @change="formErrors.publishing_year = null"
            />
          </v-col>
          <v-col
            class="mr-auto"
          >
            <v-select
              v-model="grade_level_group"
              :error-messages="formErrors.grade_level_group_id || formErrors.grade_level_id"
              :items="gradelevelGroups"
              item-text="name"
              item-value="id"
              label="Segmento"
              :readonly="teaching_system_id ? false : true"
              placeholder="Escolha o segmento de ensino"
              hide-details="auto"
              outlined
              @change="() => { getGradeLevel(grade_level_group); formErrors.grade_level_group_id = null; formErrors.grade_level_id = null }"
            />
          </v-col>
          <v-col
            v-if="!hideGradeLevelField"
            class="mr-auto"
          >
            <v-select
              v-model="grade_level_id"
              :error-messages="formErrors.grade_level_id"
              :items="gradelevels"
              item-text="name"
              item-value="id"
              :readonly="grade_level_group ? false : true"
              label="Ano"
              placeholder="Escolha o ano de ensino"
              hide-details="auto"
              outlined
              @change="() => { getSubjects(); formErrors.grade_level_id = null }"
            />
          </v-col>
          <v-col
            v-if="!hideSubjectField"
            cols="12"
            class="mr-auto"
          >
            <v-select
              v-model="subject_id"
              :error-messages="formErrors.subject_id"
              :items="subjects"
              item-text="name"
              item-value="id"
              label="Matéria"
              placeholder="Escolha uma matéria"
              hide-details="auto"
              outlined
              @change="formErrors.subject_id = null"
            />
          </v-col>
          <v-col
            v-if="enableName"
            cols="12"
            class="mr-auto"
          >
            <v-text-field
              v-model="name"
              :error-messages="formErrors.name"
              label="Nome do material"
              placeholder="Insira o titulo do material que será enviado"
              hide-details="auto"
              outlined
              @input="formErrors.name = null"
            />
          </v-col>
          <v-col
            v-if="!hideVolumeField"
            cols="4"
            class="mr-auto"
          >
            <v-select
              v-model="volume"
              :error-messages="formErrors.volume_id"
              :items="volumes"
              item-text="name"
              item-value="id"
              label="Volume"
              outlined
              @change="formErrors.volume_id = null"
            />
          </v-col>
          <v-col
            cols="4"
            class="mr-auto"
          >
            <v-text-field
              v-model="order"
              :error-messages="formErrors.order"
              label="Ordem"
              type="number"
              hide-details="auto"
              outlined
              @change="formErrors.order = null"
            />
            <span style="font-size: 12px; color: blue"> Preencher ordem com ( -1 ) para materiais paradidaticos</span>
          </v-col>
          <v-col
            cols="6"
            class="mr-auto"
          >
            Material do professor
            <v-switch
              v-model="is_teacher_material"
              class="ma-2"
              :label="is_teacher_material ? 'Sim' : 'Não'"
            />
          </v-col>
          <v-col
            cols="6"
            class="mr-auto"
          >
            Publicar material quando salvar
            <v-switch
              v-model="should_publish_after_processing"
              class="ma-2"
              :label="should_publish_after_processing ? 'Sim' : 'Não'"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <template v-else>
      Usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'
import { types as materialTypes, listTypes } from '@/enums/materialTypes'
import { listTypes as listVolumeTypes } from '@/enums/volumeTypes'
import UploadFileDialog from '@/components/settings/UploadFileDialog.vue'
import UploadImageDialog from '@/components/settings/UploadImageDialog.vue'
import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
    ItemPage
  },

  mixins: [
    handlesServerValidation
  ],
  data () {
    return {
      subjectTextBooksCreate: false,
      loading: false,
      loadingCover: false,
      loadingMaterial: false,
      name: '',
      years: [
        new Date().getFullYear() + 1,
        new Date().getFullYear(),
        new Date().getFullYear() - 1,
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 3
      ],
      is_teacher_material: false,
      is_published: false,
      should_publish_after_processing: true,
      subject_id: null,
      subjects: [],
      teaching_system_id: null,
      systems: [],
      temporary_upload_file: null,
      cover_temporary_upload_file: null,
      publishing_year: null,
      grade_level_group: null,
      gradelevelGroups: [],
      grade_level_id: null,
      type: null,
      gradelevels: [],
      files: [],
      types: [],
      order: 0,
      volume: null,
      volumes: [],
      errors: [],
      hideGradeLevelField: false,
      hideVolumeField: false,
      hideSubjectField: false
    }
  },
  computed: {
    formDisabled () {
      return !this.cover_temporary_upload_file || !this.temporary_upload_file
    },
    actions () {
      return [
        {
          label: 'Salvar',
          action: this.newMaterial,
          icon: 'mdi-floppy',
          disabled: this.formDisabled
        }
      ]
    },
    displayCoverButton () {
      if (!this.cover_temporary_upload_file) {
        return true
      }
      return false
    },
    displayMaterialButton () {
      if (!this.temporary_upload_file) {
        return true
      }
      return false
    },
    enableName () {
      if (this.hideSubjectField) {
        return true
      }
      if (this.subject_id) {
        return false
      }
      return true
    }
  },
  watch: {
    type (newVal) {
      this.hideVolumeField = false
      this.hideSubjectField = false
      this.hideGradeLevelField = false
      if ([materialTypes.Additional].includes(newVal)) {
        this.subject_id = null
        this.volume = null
        this.name = ''
        this.hideVolumeField = true
        this.hideSubjectField = true
      }
      if ([materialTypes.Activity].includes(newVal)) {
        this.subject_id = null
        this.name = ''
        this.hideSubjectField = true
      }
      if ([materialTypes.Project, materialTypes.Supplementary].includes(newVal)) {
        this.grade_level_id = null
        this.subject_id = null
        this.volume = null
        this.name = ''
        this.hideVolumeField = true
        this.hideSubjectField = true
        this.hideGradeLevelField = true
      }
    },
    subject_id (newVal) {
      const selectedSubject = this.subjects.find(subject => subject.id === newVal)
      this.name = selectedSubject ? selectedSubject.name : ''
      if (!newVal) {
        this.name = ''
      }
    }
  },
  created () {
    this.subjectTextBooksCreate = utils.checkPermissions('subject-textbooks.create')
    this.fetchAll()
  },
  methods: {
    listTypes,
    listVolumeTypes,
    async fetchAll () {
      this.types = listTypes()
      await this.getGradeLevelGroups()
      await this.getTeachingSystems()
    },

    async confirmNewMaterial () {
      this.$dialog.confirm('Deseja cadastrar um novo material ?')
        .cancelLabel('não')
        .label('Sim')
        .onConfirm(() => {
          this.resetForm()
        })
        .onCancel(() => {
          this.$router.go(-1)
        })
        .show()
    },
    async getTeachingSystems () {
      try {
        const response = await this.$api.getTeachingSystems()
        this.systems = response
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter sistemas de ensino.', color: 'red' })
      }
    },
    async getGradeLevelGroups () {
      try {
        const response = await this.$api.getGradeLevelGroups()
        this.gradelevelGroups = response
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter segmentos.', color: 'red' })
      }
    },
    async getGradeLevel (id) {
      try {
        const response = await this.$api.getGradeLevels(id)
        this.gradelevels = response
        this.subjects = []
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter cursos.', color: 'red' })
      }
    },
    async getSubjects () {
      if ([materialTypes.Additional, materialTypes.Activity].includes(this.type)) {
        return this.getVolumes()
      }
      try {
        const response = await this.$api.getSubjectsOfGradeLevel(this.grade_level_id, this.teaching_system_id)
        this.subjects = [
          ...response,
          {
            id: null,
            name: 'Outra'
          }
        ]
        this.subject_id = this.subjects[0].id
        await this.getVolumes()
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter matérias.', color: 'red' })
      }
    },
    async getVolumes () {
      try {
        this.volumes = await this.$api.getVolumes(this.grade_level_id, this.teaching_system_id)
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter volumes.', color: 'red' })
      }
    },
    openUploadCoverDialog () {
      this.$dialog.custom(UploadImageDialog).with({ title: 'da capa' }).show()
        .then(async (formData) => {
          if (!formData) {
            return
          }
          try {
            this.loadingCover = true
            const idTempFile = await this.$api.uploadCoverMaterial(formData)
            this.cover_temporary_upload_file = idTempFile.id
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar a capa, tente novamente mais tarde.', color: 'red' })
          } finally {
            this.loadingCover = false
          }
        })
    },

    openUploadMaterialDialog () {
      this.$dialog.custom(UploadFileDialog).with({ title: 'do material' }).show()
        .then(async (formData) => {
          if (!formData) {
            return
          }
          try {
            this.loadingMaterial = true
            const idTempFile = await this.$api.uploadMaterial(formData)
            this.temporary_upload_file = idTempFile.id
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar o material, tente novamente mais tarde.', color: 'red' })
          } finally {
            this.loadingMaterial = false
          }
        })
    },

    resetForm () {
      this.name = ''
      this.temporary_upload_file = null
      this.cover_temporary_upload_file = null
      this.subject_id = null
      this.type = null
      this.grade_level_group = null
      this.grade_level_id = null
      this.order = 0
      this.formDisabled = true
      this.publishing_year = null
    },
    async newMaterial () {
      this.cleanFormErrors()
      this.loading = true
      const data = {
        teaching_system_id: this.teaching_system_id,
        grade_level_group_id: this.grade_level_group,
        grade_level_id: this.grade_level_id,
        temporary_upload_file_id: this.temporary_upload_file,
        cover_temporary_upload_file_id: this.cover_temporary_upload_file,
        name: this.name,
        subject_id: this.subject_id,
        publishing_year: this.publishing_year,
        order: this.order,
        is_teacher_material: this.is_teacher_material,
        type: this.type,
        should_publish_after_processing: this.should_publish_after_processing,
        volume_id: this.volume
      }
      try {
        await this.$api.NewMaterialTextBook(data)
        this.$store.dispatch('setSnackBar', { text: 'Material cadastrado com sucesso.' })
        this.confirmNewMaterial()
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível cadastrar o material.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
